import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
const benefits = ['All 5 volumes: The AI Agent Blueprint · The Viral Listing Engine · The Ghost Lead Recovery Protocol · The NAR-Proof Negotiation Vault · The Referral & Review Machine', 'BONUS 1 — the 300+ page 365-Day Omnipresence Calendar (Parts A & B): ready-to-post content for every single day of the year', 'Works in any market condition, in any of 12 countries', '7-day money-back guarantee, no questions asked'];
export function FinalCTASection() {
  return <section id="get-access" className="relative w-full overflow-hidden bg-navy-800 py-20 lg:py-28" aria-labelledby="cta-heading" data-id="element-28" data-mp="39byc88u92bd9">
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 top-0 h-[520px] w-[520px] rounded-full bg-navy-700 opacity-70 blur-3xl animate-drift" data-id="element-29" data-mp="3e3gauq8svzv2" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-brand-gold/10 blur-3xl animate-drift" data-id="element-30" data-mp="2llu7tz98m7l7" />

      <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-8" data-id="element-31" data-mp="26x3nxh2nml5x">
        <Reveal data-id="element-32" data-mp="21x905me6ebp3">
          <h2 id="cta-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-33" data-mp="21wpnol7aofig">
            Ready to dominate your market?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-34" data-mp="1s5la9px9p2pq">
            Join 2,000+ agents who&rsquo;ve already transformed their business with AI.
          </p>

          <ul className="mt-8 inline-flex flex-col items-start gap-3 text-left" data-id="element-35" data-mp="1j4n6n8qqqx7o">
            {benefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-[15px] font-medium text-slate-200" data-id="element-36" data-mp="1e6vdkbed151w">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" data-id="element-37" data-mp="1993caqrts6l1" />
                {benefit}
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-38" data-mp="33l1kqqib8yfv">
            <CTAButton href="https://the-real-estate-growth-system.impultienda.ar/checkout" data-id="element-39" data-mp="33lt8xg9kvtw4">GET THE SYSTEM NOW — $21 USD</CTAButton>
            <p className="mt-4 text-sm text-slate-400" data-id="element-40" data-mp="16mu7t54fn4li">
              Limited time: includes all 5 bonuses{' '}
              <span className="font-semibold text-brand-gold" data-id="element-41" data-mp="ry7vlca3qsyi">free</span>.
            </p>
          </div>
        </Reveal>

      </div>
    </section>;
}